import { render } from "./Performance.vue?vue&type=template&id=745cbb30&scoped=true&lang=pug"
import script from "./Performance.vue?vue&type=script&lang=js"
export * from "./Performance.vue?vue&type=script&lang=js"

import "./Performance.vue?vue&type=style&index=0&id=745cbb30&lang=scss&scoped=true"
import "./Performance.vue?vue&type=style&index=1&id=745cbb30&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745cbb30"]])

export default __exports__